import React from 'react'
import {
  DetailsList,
  DetailsListLayoutMode,
  CheckboxVisibility
} from 'office-ui-fabric-react/lib/DetailsList'
import { IconButton } from 'office-ui-fabric-react/lib/Button'

function renderItemColumn(item, index, column) {
  const handleDelete = column.handleDelete
  const html = item.formattedString || (item.formatted_data ? item.formatted_data.output : '...')
  return <div className="eb-action-list-item">
    <div className="eb-action-list-item-text" dangerouslySetInnerHTML={{__html: html}} />
    <IconButton
      className="eb-action-list-item-action"
      iconProps={ { iconName: 'Delete' } }
      title='delete'
      ariaLabel='delete'
      onClick={() => handleDelete(item)}
    />
  </div>
}

const CitationList = ({items, handleDelete, allowDelete}) =>
  <div>{
      (items.length > 0) ? <DetailsList
      items={items}
      columns={[{key: 'title', handleDelete}]}
      setKey='set'
      layoutMode={ DetailsListLayoutMode.justified }
      isHeaderVisible={ false }
      onRenderItemColumn={ renderItemColumn }
      checkboxVisibility={CheckboxVisibility.hidden}
    />
    : <div className={'eb-empty-list ms-font-l'}>Your bibliography is empty. To create a citation, search for your source above!</div>
  }</div>


  export default CitationList



// WEBPACK FOOTER //
// ./src/CitationList.js